export default {
  path: '/trackers/tracker-search',
  name: 'TrackerSearch',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerSearchView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
